import React from 'react'
import styled from 'styled-components'

const Button = styled.div`
  display: inline-block;
  font-size: 14px;
  width: 100%;
  text-align: center;
  padding: 5px 0;
  margin-bottom: 5px;
  background-color: #ff56ff;
  color: white;
  font-family: 'Inconsolata', 'Lucida Console', mono;
  cursor: pointer;
  text-transform: lowercase;
  opacity: 0.7;
  box-sizing: border-box;
  box-shadow: -2px 2px 0 blue;
  font-weight: 700;
  &:hover {
    opacity: 0.9;
  }
`

class Nav extends React.Component {

  render() {
    return (
      <div>
        <Button>Home</Button>
        <Button>Another</Button>
      </div>
    )
  }
}

export default Nav



// WEBPACK FOOTER //
// ./src/components/Nav.js